var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductHostingService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEA\xB2\xA9\xEB\xA6\xAC_\xEB\xAA\xA8\xEB\x93\x9C",
    clipPath: "url(#clip0_2881_52540)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.7551 24.2521C43.5497 12.7917 35.7141 2.04637 24.2537 0.251719C12.7934 -1.54293 2.04805 6.29269 0.253401 17.7531C-1.54125 29.2134 6.29437 39.9588 17.7547 41.7534C29.2151 43.548 39.9604 35.7124 41.7551 24.2521Z",
    fill: "url(#paint0_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.98828 7.42417C11.9051 10.2788 17.3013 11.7993 17.3013 11.7993C12.6057 10.2267 8.66282 7.7074 7.5299 6.03784C7.35101 5.77697 7.15723 5.57573 6.94853 5.4043C6.24791 6.03038 5.59946 6.70864 4.98828 7.42417Z",
    fill: "url(#paint1_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.1211 13.9759C8.61679 13.6256 6.39568 12.7237 5.66524 11.9933C4.93481 11.2628 3.24288 11.1883 2.81058 10.8231C2.75841 10.7784 2.7286 10.756 2.68388 10.7188C2.39319 11.233 2.12487 11.7622 1.87891 12.3063C6.83543 13.5734 11.1211 13.9684 11.1211 13.9684V13.9759Z",
    fill: "url(#paint2_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.1367 9.78718C23.1367 9.78718 25.4249 10.3238 26.8187 9.98097C28.2125 9.63811 28.8609 10.3611 29.8224 9.87662C30.7839 9.39215 31.5144 10.0406 31.738 10.5027C31.9616 10.9648 32.6845 10.5027 33.169 10.9201C33.6535 11.3375 34.9504 11.3077 34.9504 11.3077C34.9504 11.3077 30.8808 12.8058 23.1442 9.78718H23.1367Z",
    fill: "url(#paint3_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.7189 11.486C39.1375 11.8661 37.9375 12.0599 37.9375 12.0599C38.5487 12.3282 39.3611 12.4549 40.2108 12.5071C40.0543 12.1568 39.8977 11.8214 39.7263 11.4785L39.7189 11.486Z",
    fill: "url(#paint4_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.5312 6.00843C16.5312 6.00843 19.207 6.90284 20.4816 6.66433C20.4816 6.66433 19.7139 6.41091 19.4157 6.14259C19.1176 5.87427 18.4393 5.70284 18.1486 5.88172C17.858 6.0606 17.7462 5.62831 17.4257 5.78483C17.0977 5.9488 16.5312 6.00843 16.5312 6.00843Z",
    fill: "url(#paint5_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.0352 13.9381C15.0352 13.9381 17.7109 14.8325 18.9855 14.594C18.9855 14.594 18.2178 14.3406 17.9196 14.0723C17.6215 13.804 16.9432 13.6325 16.6525 13.8114C16.3619 13.9903 16.2501 13.558 15.9296 13.7145C15.6016 13.8785 15.0352 13.9381 15.0352 13.9381Z",
    fill: "url(#paint6_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M29.6519 6.56767C29.6519 6.56767 27.5947 6.41115 26.8047 5.88941C26.8047 5.88941 27.3935 5.93413 27.6693 5.84469C27.9451 5.7478 28.4519 5.82233 28.601 6.03103C28.7426 6.23227 28.9438 5.9714 29.1152 6.17264C29.2867 6.37388 29.6519 6.57513 29.6519 6.57513V6.56767Z",
    fill: "url(#paint7_linear_2881_52540)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M37.2763 12.9988C36.1657 12.9988 35.1148 12.7752 34.1757 12.3653C33.557 12.097 32.8639 12.097 32.2452 12.3653C31.3061 12.7678 30.2552 12.9988 29.1446 12.9988C28.0341 12.9988 26.9831 12.7752 26.044 12.3653C25.4254 12.097 24.7322 12.097 24.1136 12.3653C23.1744 12.7678 22.1235 12.9988 21.0129 12.9988C19.9024 12.9988 18.8515 12.7752 17.9123 12.3653C17.2937 12.097 16.6005 12.097 15.9819 12.3653C15.0428 12.7678 13.9918 12.9988 12.8813 12.9988C11.7707 12.9988 10.7198 12.7752 9.78065 12.3653C9.16202 12.097 8.46885 12.097 7.85021 12.3653C6.91108 12.7678 5.86015 12.9988 4.74959 12.9988C3.71357 12.9988 2.73717 12.7976 1.84276 12.4473C0.419159 15.5852 -0.236742 19.1181 0.083755 22.8448C0.970712 33.1231 9.43034 41.3516 19.731 41.9628C31.9098 42.6784 42.0018 33.0187 42.0018 21.0038C42.0018 17.9554 41.3459 15.0634 40.1831 12.4473C39.2887 12.8051 38.3123 12.9988 37.2763 12.9988Z",
    fill: "url(#paint8_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M37.1636 28.449C37.1636 28.449 37.6108 27.8229 37.7598 27.4726C37.9015 27.1223 39.012 28.2851 38.3859 28.926C37.7598 29.567 36.9102 29.9397 36.9102 29.9397",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M40.6192 30.4927L28.9844 18.8579C28.8353 18.7088 28.5968 18.7088 28.4477 18.8579C28.2987 19.007 28.2987 19.2455 28.4477 19.3945L40.0825 31.0293C40.172 31.1188 40.2241 31.238 40.2241 31.3647V31.3945C40.2241 31.5362 40.3061 31.6629 40.4254 31.7225L41.8117 32.3933C41.9235 32.4455 42.0353 32.3337 41.9831 32.2219L41.3123 30.8355C41.2527 30.7088 41.126 30.6268 40.9844 30.6268H40.9546C40.8279 30.6268 40.7086 30.5747 40.6192 30.4852V30.4927Z",
    fill: "url(#paint9_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M36.8573 28.7332C36.8573 28.7332 36.6188 27.9357 37.0958 27.7344C37.5803 27.5332 38.1989 27.9655 37.9232 28.0624C37.6474 28.1593 37.394 28.2114 37.394 28.2114C37.394 28.2114 38.4151 29.1058 37.5579 29.5829C36.7008 30.0524 36.3281 29.5009 36.3281 29.5009",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M20.8468 38.5711C20.8468 38.5711 20.8766 38.6233 21.5847 38.0569C22.1288 37.6171 22.7474 38.6457 22.5536 38.9736C22.3598 39.3016 20.8542 39.5028 19.8555 38.7873",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M18.8956 24.2451H12.1577C11.1068 24.2451 10.2422 23.3805 10.2422 22.3296C10.2422 21.2787 11.1068 20.4141 12.1577 20.4141H18.8956C19.9465 20.4141 20.8111 21.2787 20.8111 22.3296C20.8111 23.3805 19.9465 24.2451 18.8956 24.2451Z",
    fill: "url(#paint10_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M10.2418 22.3295C10.2418 23.3804 11.1064 24.245 12.1574 24.245H18.8952C19.3052 24.245 19.6779 24.1183 19.9909 23.8947C19.8195 23.8723 19.6629 23.768 19.73 23.3953C19.8642 22.6798 18.8878 22.6425 18.8878 22.6425C18.8878 22.6425 13.9238 22.6127 11.9188 22.6425C10.0629 22.6723 10.3536 21.6959 10.4058 21.5469C10.294 21.7854 10.2344 22.0537 10.2344 22.3295H10.2418Z",
    fill: "url(#paint11_linear_2881_52540)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M16.3828 22.8741C16.3828 22.8741 19.707 21.7635 29.1207 27.8604C34.3679 31.2667 36.8648 28.7325 36.8648 28.7325L37.5654 29.5747C37.5654 29.5747 32.9592 32.7126 27.2797 29.9996C22.04 27.5027 19.9008 29.1573 19.9008 29.1573",
    fill: "url(#paint12_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M0.402485 16.9043C0.141615 18.231 0 19.6024 0 21.0037C0 21.0782 0 21.1527 0 21.2273C2.76522 31.9453 14.1168 27.9503 14.1168 27.9503L8.54162 22.7105C3.89068 22.9565 1.32671 18.8124 0.402485 16.9043Z",
    fill: "url(#paint13_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M0.0972972 22.9785C0.246366 24.6108 0.589223 26.1909 1.09606 27.6965C3.40661 28.6431 6.26873 29.2319 9.81655 29.0978L10.7259 24.7003C10.7259 24.7003 5.4414 24.894 0.0898438 22.9785H0.0972972Z",
    fill: "url(#paint14_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M8.04393 22.77C8.04393 22.77 17.07 21.3539 23.3309 26.1389L22.9433 28.5464C22.9433 28.5464 11.316 29.5899 6.52344 29.0085L8.04393 22.77Z",
    fill: "url(#paint15_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M14.1023 22.7338C13.5135 22.6667 12.947 22.6294 12.4104 22.5996C11.8961 23.5462 10.7855 26.2071 12.388 29.1586C12.9694 29.1437 13.5582 29.1288 14.147 29.1064C13.7296 28.1524 12.5371 24.9772 14.0948 22.7338H14.1023Z",
    fill: "url(#paint16_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M17.3281 23.3139C16.8063 23.1798 16.2921 23.068 15.7852 22.9785C15.256 24.1263 14.548 26.4593 15.8821 29.0307C16.4858 29.0009 17.0747 28.9711 17.6411 28.9338C17.2163 27.9127 16.3591 25.3711 17.3281 23.3214V23.3139Z",
    fill: "url(#paint17_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M19.5349 26.125C19.5349 26.125 13.9448 27.9511 14.9286 33.2207C15.9125 38.4902 20.9212 39.2132 20.9212 39.2132V38.5648C20.9212 38.5648 16.7696 35.6579 17.6566 32.0952C18.5436 28.5325 22.0318 28.6219 22.0318 28.6219L20.3249 26.125H19.5274H19.5349Z",
    fill: "url(#paint18_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M25.3621 22.9032C24.9224 22.8436 24.5348 23.1865 24.5348 23.6337V24.7368C24.5348 25.2063 24.1845 25.5939 23.7149 25.6461C23.5584 25.661 23.387 25.6759 23.2155 25.6759C22.1721 25.6759 22.187 27.7927 23.5211 27.8821C23.5733 27.8821 23.6255 27.8821 23.6702 27.897C24.177 27.979 27.0466 28.2995 27.4565 27.7256C27.7099 27.3604 27.7174 27.2337 27.7099 26.7567C27.7099 26.5629 27.8516 26.3989 28.0454 26.384C28.2839 26.3616 28.5671 26.2796 28.5745 26.0113C28.6193 23.6635 26.5547 23.0523 25.3621 22.9032Z",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M28.4697 26.2348C28.3728 26.2646 28.194 26.2944 28.1492 26.19C28.1045 26.0857 28.2238 25.795 28.1716 25.6683C28.1194 25.5341 28.1716 25.3553 28.1716 25.3553L25.5778 24.2969L24.5418 24.4758V24.7366C24.5418 25.2062 24.1915 25.5938 23.7219 25.6459C23.5654 25.6609 23.394 25.6758 23.2225 25.6758C22.7157 25.6758 22.4623 26.1677 22.4772 26.6894C22.6412 26.1304 23.5058 26.3018 24.0648 26.9503C24.4971 27.4422 25.7865 27.8149 26.3679 27.9565C26.0399 27.7553 25.9803 27.1515 26.0101 26.6149C26.0399 25.9515 26.912 26.0857 27.4263 25.9739C27.8958 25.8695 27.9331 26.3317 27.9405 26.4136C27.9778 26.3987 28.0151 26.3838 28.0598 26.3838C28.2089 26.3689 28.3728 26.3317 28.4772 26.2422L28.4697 26.2348Z",
    fill: "url(#paint19_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M23.4766 25.6773C23.4766 25.6773 24.6766 25.7891 24.9002 25.476C24.9002 25.476 24.9747 25.3568 25.0567 25.1183C25.1312 24.8798 25.7648 24.9021 25.7051 25.476C25.6828 25.6847 25.6753 25.8189 25.6828 25.9009C25.6828 25.9829 25.7499 26.05 25.8318 26.05C25.9064 26.05 25.966 25.9978 25.9809 25.9232C25.9958 25.8487 26.0331 25.7593 26.13 25.722C26.3238 25.64 26.443 25.0437 26.443 25.0437L25.9436 24.4922L24.5424 24.6338C24.5424 24.6338 24.3188 24.7978 24.1921 25.0065C24.043 25.2524 23.4766 25.6773 23.4766 25.6773Z",
    fill: "#F16C52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M24.5417 24.6332C24.5417 24.6332 24.4821 23.5898 24.3703 23.0829C24.251 22.5761 27.5976 22.427 28.3728 24.5438C28.3728 24.5438 26.0846 25.2891 24.5417 24.6407V24.6332Z",
    fill: "url(#paint20_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M28.1942 24.4551H26.7333C26.3681 24.4551 26.0625 24.7532 26.0625 25.1259C26.0625 25.4986 26.3606 25.7967 26.7333 25.7967H27.337C27.501 25.7967 27.6501 25.7296 27.7619 25.6178L27.8439 25.5358C27.9557 25.424 28.1047 25.3644 28.2613 25.3644H28.455C28.5519 25.3644 28.6265 25.275 28.619 25.1781C28.5892 24.947 28.4998 24.7309 28.3656 24.552C28.3209 24.4998 28.2613 24.4625 28.1867 24.4625L28.1942 24.4551Z",
    fill: "#00A887"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M27.7007 25.3108C27.8274 25.184 27.9914 25.117 28.1702 25.117H28.6174C28.5951 24.9754 28.5504 24.8337 28.4758 24.707H26.933C26.8733 24.707 26.8137 24.7145 26.7615 24.7294L26.6796 24.7517C26.5678 24.7816 26.4858 24.8636 26.4485 24.9754C26.441 25.0126 26.4336 25.0424 26.4336 25.0797V25.1393C26.4336 25.2511 26.4858 25.3555 26.5827 25.4226C26.7243 25.5195 26.8957 25.5716 27.0671 25.5716C27.3056 25.5716 27.5292 25.4747 27.6932 25.3108H27.7007Z",
    fill: "url(#paint21_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M27.0687 26.5633L26.9793 26.6527C26.86 26.772 26.793 26.9285 26.793 27.0999V27.4652C26.793 27.7633 27.0315 28.0018 27.3296 28.0018C27.4563 28.0018 27.5756 27.9571 27.6725 27.8751C27.911 27.6738 28.0526 27.3757 28.0526 27.0627V26.377H27.5159C27.352 26.377 27.188 26.444 27.0687 26.5633Z",
    fill: "#00A887"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M27.0687 26.5633L26.9793 26.6527C26.86 26.772 26.793 26.9285 26.793 27.0999V27.4652C26.793 27.7633 27.0315 28.0018 27.3296 28.0018C27.4563 28.0018 27.5756 27.9571 27.6725 27.8751C27.911 27.6738 28.0526 27.3757 28.0526 27.0627V26.377H27.5159C27.352 26.377 27.188 26.444 27.0687 26.5633Z",
    fill: "url(#paint22_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M27.577 26.7435L27.5173 26.8032C27.4353 26.8852 27.3906 26.997 27.3906 27.1088V27.3622C27.3906 27.5634 27.5546 27.7348 27.7633 27.7348C27.8527 27.7348 27.9347 27.705 28.0018 27.6454C28.1658 27.5038 28.2627 27.3025 28.2627 27.0864V26.8553C28.2627 26.7212 28.1509 26.6094 28.0167 26.6094H27.89C27.7707 26.6094 27.6664 26.6541 27.5844 26.7361L27.577 26.7435Z",
    fill: "#00A887"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M27.577 26.7435L27.5173 26.8032C27.4353 26.8852 27.3906 26.997 27.3906 27.1088V27.3622C27.3906 27.5634 27.5546 27.7348 27.7633 27.7348C27.8527 27.7348 27.9347 27.705 28.0018 27.6454C28.1658 27.5038 28.2627 27.3025 28.2627 27.0864V26.8553C28.2627 26.7212 28.1509 26.6094 28.0167 26.6094H27.89C27.7707 26.6094 27.6664 26.6541 27.5844 26.7361L27.577 26.7435Z",
    fill: "url(#paint23_linear_2881_52540)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M16.2276 23.6787H9.48975C8.43881 23.6787 7.57422 22.8141 7.57422 21.7632C7.57422 20.7123 8.43881 19.8477 9.48975 19.8477H16.2276C17.2786 19.8477 18.1432 20.7123 18.1432 21.7632C18.1432 22.8141 17.2786 23.6787 16.2276 23.6787Z",
    fill: "url(#paint24_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M7.57386 21.7631C7.57386 22.814 8.43846 23.6786 9.48939 23.6786H16.2273C16.6372 23.6786 17.0099 23.5519 17.3229 23.3283C17.1515 23.3059 16.995 23.2016 17.0621 22.8289C17.1962 22.1134 16.2198 22.0761 16.2198 22.0761C16.2198 22.0761 11.2558 22.0463 9.25088 22.0761C7.39498 22.1059 7.68566 21.1295 7.73784 20.9805C7.62603 21.219 7.56641 21.4873 7.56641 21.7631H7.57386Z",
    fill: "url(#paint25_linear_2881_52540)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M18.4158 21.9277C18.4158 22.2855 18.2444 22.5762 18.0282 22.5762C17.8121 22.5762 17.6406 22.2855 17.6406 21.9277C17.6406 21.57 17.8121 21.2793 18.0282 21.2793C18.2444 21.2793 18.4158 21.57 18.4158 21.9277Z",
    fill: "#00A887"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M21.2048 22.3965C21.2048 22.7543 21.0334 23.0449 20.8173 23.0449C20.6011 23.0449 20.4297 22.7543 20.4297 22.3965C20.4297 22.0387 20.6011 21.748 20.8173 21.748C21.0334 21.748 21.2048 22.0387 21.2048 22.3965Z",
    fill: "#00A887"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M18.1406 21.9286C18.1406 21.9286 21.9866 21.7497 21.7257 24.2466C21.4648 26.7435 21.4648 30.1273 25.9071 31.1037C30.3493 32.0801 29.9021 27.6081 27.9866 27.1907",
    stroke: "#00A887",
    strokeWidth: 0.583333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M28.5845 15.4065C28.495 15.4884 28.3534 15.4884 28.264 15.4065C27.8838 15.0338 27.3621 14.8027 26.7882 14.8027C26.1546 14.8027 25.5807 15.086 25.1932 15.5257C25.1335 15.5928 25.1335 15.6971 25.1932 15.7642C25.5807 16.204 26.1472 16.4872 26.7882 16.4872C27.3621 16.4872 27.8838 16.2561 28.264 15.8835C28.3534 15.8015 28.495 15.794 28.5845 15.8835C28.6664 15.9655 28.7484 16.0325 28.8453 16.0996C28.9348 16.1593 29.0615 16.0996 29.0615 15.9953V15.2947C29.0615 15.1829 28.9348 15.1232 28.8453 15.1903C28.7559 15.2574 28.6664 15.3245 28.5845 15.4065Z",
    fill: "url(#paint26_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M10.3618 31.842C10.2724 31.924 10.1307 31.924 10.0413 31.842C9.66118 31.4693 9.13945 31.2383 8.56553 31.2383C7.93199 31.2383 7.35808 31.5215 6.9705 31.9613C6.91087 32.0283 6.91087 32.1327 6.9705 32.1998C7.35808 32.6395 7.92454 32.9228 8.56553 32.9228C9.13945 32.9228 9.66118 32.6917 10.0413 32.319C10.1307 32.237 10.2724 32.2296 10.3618 32.319C10.4438 32.401 10.5258 32.4681 10.6227 32.5352C10.7121 32.5948 10.8388 32.5352 10.8388 32.4308V31.7302C10.8388 31.6184 10.7121 31.5588 10.6227 31.6259C10.5332 31.6929 10.4438 31.76 10.3618 31.842Z",
    fill: "url(#paint27_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M13.8951 15.7638C13.9547 15.8234 14.0516 15.8234 14.1112 15.7638C14.3646 15.5178 14.715 15.3613 15.1025 15.3613C15.5274 15.3613 15.9075 15.5477 16.1684 15.8458C16.2056 15.8905 16.2056 15.9576 16.1684 16.0023C15.9075 16.3005 15.5274 16.4868 15.1025 16.4868C14.715 16.4868 14.3721 16.3303 14.1112 16.0843C14.0516 16.0247 13.9547 16.0247 13.8951 16.0843C13.8429 16.1365 13.7833 16.1887 13.7236 16.2259C13.664 16.2706 13.582 16.2259 13.582 16.1514V15.6818C13.582 15.6073 13.664 15.57 13.7236 15.6073C13.7833 15.652 13.8429 15.6967 13.8951 15.7489V15.7638Z",
    fill: "url(#paint28_linear_2881_52540)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M27.063 34.7482C27.1227 34.8078 27.2196 34.8078 27.2792 34.7482C27.5326 34.5022 27.8829 34.3457 28.2705 34.3457C28.6953 34.3457 29.0755 34.532 29.3363 34.8302C29.3736 34.8749 29.3736 34.942 29.3363 34.9867C29.0755 35.2848 28.6953 35.4712 28.2705 35.4712C27.8829 35.4712 27.5401 35.3146 27.2792 35.0687C27.2196 35.0091 27.1227 35.0091 27.063 35.0687C27.0109 35.1209 26.9512 35.173 26.8916 35.2103C26.832 35.255 26.75 35.2103 26.75 35.1358V34.6662C26.75 34.5917 26.832 34.5544 26.8916 34.5917C26.9512 34.6364 27.0109 34.6811 27.063 34.7333V34.7482Z",
    fill: "url(#paint29_linear_2881_52540)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2881_52540",
    x1: 21.0045,
    y1: 30.9387,
    x2: 21.0045,
    y2: -32.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2881_52540",
    x1: 11.1448,
    y1: 3.48132,
    x2: 11.1448,
    y2: -13.6541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2881_52540",
    x1: 6.50002,
    y1: 5.75477,
    x2: 6.50002,
    y2: -8.52597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2881_52540",
    x1: 29.0398,
    y1: 0.00084638,
    x2: 29.0398,
    y2: -24.2898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2881_52540",
    x1: 39.0704,
    y1: 3.76422,
    x2: 39.0704,
    y2: -13.1774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2881_52540",
    x1: 18.499,
    y1: 0.000978816,
    x2: 18.499,
    y2: -24.2897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2881_52540",
    x1: 17.0103,
    y1: 0.000226346,
    x2: 17.0103,
    y2: -24.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2881_52540",
    x1: 28.2283,
    y1: 0.00121624,
    x2: 28.2283,
    y2: -24.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2881_52540",
    x1: 21.0055,
    y1: 44.2287,
    x2: 21.0055,
    y2: 17.8659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2881_52540",
    x1: 34.7528,
    y1: 19.1514,
    x2: 36.2759,
    y2: 42.6414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDDFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2881_52540",
    x1: 16.1453,
    y1: 15.4948,
    x2: 15.2658,
    y2: 25.2439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#40D3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15A189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2881_52540",
    x1: 10.2418,
    y1: 22.8959,
    x2: 19.9984,
    y2: 22.8959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#40D3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15A189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2881_52540",
    x1: 36.7306,
    y1: 46.7772,
    x2: 33.1679,
    y2: 39.2791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2881_52540",
    x1: 21.0112,
    y1: 54.2459,
    x2: 17.4559,
    y2: 46.7478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2881_52540",
    x1: 19.5656,
    y1: 54.9313,
    x2: 16.0029,
    y2: 47.4332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2881_52540",
    x1: 26.3868,
    y1: 51.6967,
    x2: 22.8241,
    y2: 44.1911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2881_52540",
    x1: 15.265,
    y1: 35.0394,
    x2: 12.8948,
    y2: 24.9772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2881_52540",
    x1: 18.4163,
    y1: 34.2928,
    x2: 16.0386,
    y2: 24.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2881_52540",
    x1: 27.8603,
    y1: 50.9896,
    x2: 24.2976,
    y2: 43.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2881_52540",
    x1: 25.6076,
    y1: 28.2994,
    x2: 25.1008,
    y2: 21.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2881_52540",
    x1: 26.5169,
    y1: 18.7376,
    x2: 26.3753,
    y2: 23.3811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2881_52540",
    x1: 27.5218,
    y1: 25.8474,
    x2: 27.5218,
    y2: 23.5741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#256351"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2881_52540",
    x1: 26.4501,
    y1: 26.6676,
    x2: 28.0899,
    y2: 27.3906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#256351"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2881_52540",
    x1: 26.0863,
    y1: 27.5261,
    x2: 29.2912,
    y2: 26.8702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#256351"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2881_52540",
    x1: 13.7978,
    y1: 14.3247,
    x2: 11.927,
    y2: 29.1346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#40D3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15A189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2881_52540",
    x1: 13.6186,
    y1: 30.9382,
    x2: 11.7478,
    y2: 17.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#40D3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15A189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2881_52540",
    x1: 27.1087,
    y1: 39.2798,
    x2: 27.1087,
    y2: 6.17913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2881_52540",
    x1: 8.87858,
    y1: 39.2805,
    x2: 8.87858,
    y2: 6.17992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2881_52540",
    x1: 14.8864,
    y1: 39.2793,
    x2: 14.8864,
    y2: 6.17872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2881_52540",
    x1: 28.0543,
    y1: 39.2799,
    x2: 28.0543,
    y2: 6.17927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2881_52540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductHostingService);
export default __webpack_public_path__ + "static/media/icon_product_hosting_service.126565471340632c034ef2d58428601b.svg";
export { ForwardRef as ReactComponent };